import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのOrganizationロゴアイコン
 */
export function ProductLogoSmallOrganization({
  size = 20,
  color = "#0070C0",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M5.60352 8.5C5.60352 7.39543 6.49895 6.5 7.60352 6.5H12.6035C13.7081 6.5 14.6035 7.39543 14.6035 8.5V9.16667C14.6035 9.35076 14.4543 9.5 14.2702 9.5H5.93685C5.75275 9.5 5.60352 9.35076 5.60352 9.16667V8.5Z"
        fill={color}
      />
      <path
        d="M12.7285 3.5C12.7285 4.88071 11.6092 6 10.2285 6C8.8478 6 7.72852 4.88071 7.72852 3.5C7.72852 2.11929 8.8478 1 10.2285 1C11.6092 1 12.7285 2.11929 12.7285 3.5Z"
        fill={color}
      />
      <path
        d="M4.72852 17C4.72852 17.8284 4.05694 18.5 3.22852 18.5C2.40009 18.5 1.72852 17.8284 1.72852 17C1.72852 16.1716 2.40009 15.5 3.22852 15.5C4.05694 15.5 4.72852 16.1716 4.72852 17Z"
        fill={color}
      />
      <path
        d="M11.7285 17C11.7285 17.8284 11.0569 18.5 10.2285 18.5C9.40009 18.5 8.72852 17.8284 8.72852 17C8.72852 16.1716 9.40009 15.5 10.2285 15.5C11.0569 15.5 11.7285 16.1716 11.7285 17Z"
        fill={color}
      />
      <path
        d="M18.7285 17C18.7285 17.8284 18.0569 18.5 17.2285 18.5C16.4001 18.5 15.7285 17.8284 15.7285 17C15.7285 16.1716 16.4001 15.5 17.2285 15.5C18.0569 15.5 18.7285 16.1716 18.7285 17Z"
        fill={color}
      />
      <path
        d="M2.60352 12.25C2.60352 11.9739 2.82737 11.75 3.10352 11.75H4.10352V14.5C4.10352 14.7761 3.87966 15 3.60352 15H3.10352C2.82737 15 2.60352 14.7761 2.60352 14.5V12.25Z"
        fill={color}
      />
      <path
        d="M16.1035 11.75H17.1035C17.3797 11.75 17.6035 11.9739 17.6035 12.25V14.5C17.6035 14.7761 17.3797 15 17.1035 15H16.6035C16.3274 15 16.1035 14.7761 16.1035 14.5V11.75Z"
        fill={color}
      />
      <path d="M16.1035 11.75V13.25H4.10352V11.75H16.1035Z" fill={color} />
      <path
        d="M9.47852 10.5C9.47852 10.2239 9.70237 10 9.97852 10H10.4785C10.7547 10 10.9785 10.2239 10.9785 10.5V14.5C10.9785 14.7761 10.7547 15 10.4785 15H9.97852C9.70237 15 9.47852 14.7761 9.47852 14.5V10.5Z"
        fill={color}
      />
    </svg>
  );
}
